<template>
<div class="index-user-info-wrap">
  <div class="back-ground-wrap">
    <div class="triangle-down"></div>
    <div class="triangle-left"></div>
    <div class="triangle-up"></div>
    <div class="triangle-right"></div>
    <el-popover
      style="padding:0px;"
      placement="right"
      :visible-arrow="false"
      width="220"
      trigger="click">
      <div class="user-detail-wrap">
        <div>
          <div @click="uploadUserPhoto" class="user-image">
            <img v-if="userImage.length>0" style="width: 100%;height: 100%;" :src="userImage">
            <svg v-else t="1602732452262" style="margin-left: 3px;" viewBox="0 0 1085 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="22631" width="75" height="75">
              <path d="M1.763516 512c0 282.734738 229.249167 511.983904 511.983905 511.983904 282.734738 0 512-229.249167 512-512 0-282.734738-229.265262-511.967809-512-511.967808S1.763516 229.249167 1.763516 512z" fill="#F6F6F6" p-id="22632"></path>
              <path d="M513.747421 1023.983904c139.242754 0 265.737818-55.755046 357.99761-145.986796-7.886828-30.259667-16.73939-55.642377-26.750833-68.245206-39.997485-50.008928-221.635964-74.393713-221.635963-74.393713l-109.610814 29.503175-109.369381-29.37441S223.753582 759.244011 183.740002 809.236844c-10.124112 12.747689-19.250299 38.629362-27.249796 69.50066 92.259793 89.877649 218.255894 145.246401 357.241119 145.2464z" fill="#BCC0C2" p-id="22633"></path>
              <path d="M281.504478 456.003521c-2.736246-28.762779 12.747689-54.386922 34.991764-57.509463 22.26017-3.12254 42.492298 17.753411 45.630933 46.628859 2.736246 28.746683-12.747689 54.370827-34.991763 57.493367-22.372839 3.138636-42.749827-17.86608-45.630934-46.612763zM427.121077 775.725872h172.254762v-148.755234H427.104981v148.755234z m272.256523-273.125683c-22.26017-2.494813-37.261239-27.748758-33.382207-56.624207 3.750267-28.746683 24.754983-50.250362 46.870292-47.739453 22.244074 2.494813 37.245143 27.748758 33.382207 56.624207-3.879032 28.875448-24.754983 50.121597-46.870292 47.739453z" fill="#FFD9AC" p-id="22634"></path>
              <path d="M513.747421 213.749135s-183.119271 7.758064-183.119271 105.747879v198.748066c0 38.500597 62.241559 148.240176 118.125369 152.859604 28.118956 2.253379 64.752468 5.263251 64.752468 5.263251s36.858849-3.12254 64.736372-5.263251c55.88381-4.732097 117.497642-114.359007 117.497643-152.859604v-193.629676c0.498963-97.490852-181.992581-110.866268-181.992581-110.866269" fill="#FEE1B9" p-id="22635"></path>
              <path d="M625.997908 240.757498c-51.377051-22.759132-112.250487-27.137127-112.250487-27.137127h-0.241434c-7.999497 0.386294-182.749073 10.011443-182.749072 105.747878v198.748067c0 38.500597 62.241559 148.240176 118.125369 152.875699 28.118956 2.253379 64.736372 5.247155 64.736372 5.247155s36.874945-3.12254 64.752468-5.247155c55.867715-4.748192 118.125369-114.375102 118.125369-152.875699V324.615404c-0.257529-41.108079-32.867149-67.35995-70.498585-83.857906" fill="#FEE1B9" p-id="22636"></path>
              <path d="M402.124661 730.738761l96.251493 292.987614c5.11839 0.257529 10.252876 0.257529 15.371267 0.257529 4.748192 0 9.625149-0.128765 14.373341-0.257529l96.251494-292.987614-111.123798 22.743037-111.123797-22.743037z" fill="#D0D4D7" p-id="22637"></path>
              <path d="M526.49511 817.365105l25.253945-25.253945-38.130399-38.243068-37.744106 38.243068 25.253946 25.253945-31.386357 148.111412 43.876517 43.876517 43.876517-43.876517z" fill="#436B85" p-id="22638"></path>
              <path d="M513.747421 753.610563l89.748884-45.24464 46.242565 27.249795-75.246778 107.502295z" fill="#FFFFFF" p-id="22639"></path>
              <path d="M514.00495 753.610563l-89.636215-45.373405-46.242566 27.249796 90.875574 107.502295z" fill="#FFFFFF" p-id="22640"></path>
              <path d="M704.866188 437.236089H687.370307l-23.370764-162.613517s53.115373-20.875951 64.12474 43.248789c10.864508 63.738447-23.258095 119.380824-23.258095 119.380824m-391.73392 0h17.495882l23.370764-162.629613s-53.115373-20.875951-64.124741 43.248789c-10.864508 63.738447 23.258095 119.380824 23.258095 119.380824" fill="#61402F" p-id="22641"></path>
              <path d="M333.75069 290.879095s74.361522 57.863565 177.501918 57.863565c103.124301 0 200.615152-31.869224 244.974536-118.737001-2.478717 0.627727-79.109714-13.133983-174.974914-86.256146-120.748947-92.372461-347.117007 44.504244-247.50154 147.113486" fill="#61402F" p-id="22642"></path>
            </svg>
          </div>
        </div>
         <div class="user-info">
           {{userName}}
        </div>
         <div class="user-info">
           {{userTel}}
        </div>
        <div class="oprate-wrap">
          <div @click="editUser(false)" class="oprate-edit-pwd">
            <i style="font-size:24px;" class="el-icon-lock"></i>
            <span style="margin-top:5px;">改密码</span>
          </div>
          <div @click="editUser(true)" class="oprate-edit-info">
            <i style="font-size:24px;" class="el-icon-edit"></i>
            <span style="margin-top:5px;">编辑</span>
          </div>
        </div>
      </div>
      <div slot="reference" class="user-image">
        <img v-if="userImage !== ''" style="width: 100%;height: 100%;" :src="userImage">
        <svg v-else t="1602732452262" style="margin-left: 4px;" viewBox="0 0 1085 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="22631" width="90" height="90">
          <path d="M1.763516 512c0 282.734738 229.249167 511.983904 511.983905 511.983904 282.734738 0 512-229.249167 512-512 0-282.734738-229.265262-511.967809-512-511.967808S1.763516 229.249167 1.763516 512z" fill="#F6F6F6" p-id="22632"></path>
          <path d="M513.747421 1023.983904c139.242754 0 265.737818-55.755046 357.99761-145.986796-7.886828-30.259667-16.73939-55.642377-26.750833-68.245206-39.997485-50.008928-221.635964-74.393713-221.635963-74.393713l-109.610814 29.503175-109.369381-29.37441S223.753582 759.244011 183.740002 809.236844c-10.124112 12.747689-19.250299 38.629362-27.249796 69.50066 92.259793 89.877649 218.255894 145.246401 357.241119 145.2464z" fill="#BCC0C2" p-id="22633"></path>
          <path d="M281.504478 456.003521c-2.736246-28.762779 12.747689-54.386922 34.991764-57.509463 22.26017-3.12254 42.492298 17.753411 45.630933 46.628859 2.736246 28.746683-12.747689 54.370827-34.991763 57.493367-22.372839 3.138636-42.749827-17.86608-45.630934-46.612763zM427.121077 775.725872h172.254762v-148.755234H427.104981v148.755234z m272.256523-273.125683c-22.26017-2.494813-37.261239-27.748758-33.382207-56.624207 3.750267-28.746683 24.754983-50.250362 46.870292-47.739453 22.244074 2.494813 37.245143 27.748758 33.382207 56.624207-3.879032 28.875448-24.754983 50.121597-46.870292 47.739453z" fill="#FFD9AC" p-id="22634"></path>
          <path d="M513.747421 213.749135s-183.119271 7.758064-183.119271 105.747879v198.748066c0 38.500597 62.241559 148.240176 118.125369 152.859604 28.118956 2.253379 64.752468 5.263251 64.752468 5.263251s36.858849-3.12254 64.736372-5.263251c55.88381-4.732097 117.497642-114.359007 117.497643-152.859604v-193.629676c0.498963-97.490852-181.992581-110.866268-181.992581-110.866269" fill="#FEE1B9" p-id="22635"></path>
          <path d="M625.997908 240.757498c-51.377051-22.759132-112.250487-27.137127-112.250487-27.137127h-0.241434c-7.999497 0.386294-182.749073 10.011443-182.749072 105.747878v198.748067c0 38.500597 62.241559 148.240176 118.125369 152.875699 28.118956 2.253379 64.736372 5.247155 64.736372 5.247155s36.874945-3.12254 64.752468-5.247155c55.867715-4.748192 118.125369-114.375102 118.125369-152.875699V324.615404c-0.257529-41.108079-32.867149-67.35995-70.498585-83.857906" fill="#FEE1B9" p-id="22636"></path>
          <path d="M402.124661 730.738761l96.251493 292.987614c5.11839 0.257529 10.252876 0.257529 15.371267 0.257529 4.748192 0 9.625149-0.128765 14.373341-0.257529l96.251494-292.987614-111.123798 22.743037-111.123797-22.743037z" fill="#D0D4D7" p-id="22637"></path>
          <path d="M526.49511 817.365105l25.253945-25.253945-38.130399-38.243068-37.744106 38.243068 25.253946 25.253945-31.386357 148.111412 43.876517 43.876517 43.876517-43.876517z" fill="#436B85" p-id="22638"></path>
          <path d="M513.747421 753.610563l89.748884-45.24464 46.242565 27.249795-75.246778 107.502295z" fill="#FFFFFF" p-id="22639"></path>
          <path d="M514.00495 753.610563l-89.636215-45.373405-46.242566 27.249796 90.875574 107.502295z" fill="#FFFFFF" p-id="22640"></path>
          <path d="M704.866188 437.236089H687.370307l-23.370764-162.613517s53.115373-20.875951 64.12474 43.248789c10.864508 63.738447-23.258095 119.380824-23.258095 119.380824m-391.73392 0h17.495882l23.370764-162.629613s-53.115373-20.875951-64.124741 43.248789c-10.864508 63.738447 23.258095 119.380824 23.258095 119.380824" fill="#61402F" p-id="22641"></path>
          <path d="M333.75069 290.879095s74.361522 57.863565 177.501918 57.863565c103.124301 0 200.615152-31.869224 244.974536-118.737001-2.478717 0.627727-79.109714-13.133983-174.974914-86.256146-120.748947-92.372461-347.117007 44.504244-247.50154 147.113486" fill="#61402F" p-id="22642"></path>
        </svg>
        <!-- <i  class="iconfont icon-morentouxiang"></i> -->
      </div>
    </el-popover>
    <div class="user-org">
      {{userOrg}}
    </div>
    <div class="user-name">{{userName}}</div>
  </div>
  <upload-user-photo
    :user-info="userInfo"
    :visible="uploadVisible"
    @upload-photo-close="uploadClose"
    @upload-success="reloadUserInfo">
  </upload-user-photo>
  <user-edit
    :editUserFlag="editUserFlag"
    :user-info="userInfo"
    :visible="userEditVisible"
    @user-edit-close="editClose"
    @user-edit-success="reloadUserInfo">
  </user-edit>
  <init-school-base-info-dialog :user-info="userInfo" :visible="initSchoolBaseInfoVisible" @oprate-success="initSchoolSuccess"></init-school-base-info-dialog>
  <student-upgrade-dialog :user-info="userInfo" :visible="upgradeVisible" @oprate-success="upgradeSuccess"></student-upgrade-dialog>
</div>
</template>

<script>
import UploadUserPhoto from '../user/ImportUserPhoto'
import InitSchoolBaseInfoDialog from '@/views/class/InitSchoolBaseInfoDialog'
import StudentUpgradeDialog from '@/views/class/StudentUpgradeDialog'
import UserEdit from '../user/UserEdit'
import {getUserInfo} from '@/model/user-model'
import { isSchoolInitialized, isNeedUpgrade } from '@/model/customer-manager-model'
import common from '../../util/common'
import { isKaowUser } from '@/components/mixins/InfoSource'
import ChangeClassDialogVue from '../class/ChangeClassDialog.vue'

export default {
  name: 'IndexUserInfo',
  data () {
    return {
      userImage: '',
      userName: '',
      userTel: '',
      userOrg: '',
      uploadVisible: false,
      userEditVisible: false,
      initSchoolBaseInfoVisible: false,
      upgradeVisible: false,
      editUserFlag: true
    }
  },
  components: {
    UploadUserPhoto,
    UserEdit,
    InitSchoolBaseInfoDialog,
    StudentUpgradeDialog
  },
  props: {
    userInfo: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    }
  },
  mixins: [isKaowUser],
  computed: {
    userPosition () {
      return this.$store.getters.userSchoolPosition
    }
  },
  methods: {
    uploadUserPhoto () {
      this.uploadVisible = true
    },
    uploadClose () {
      this.uploadVisible = false
    },
    reloadUserInfo () {
      let param = {userId: this.userInfo.userId}
      getUserInfo(param).then((userData) => {
        if (!userData.result) {
          sessionStorage.setItem('user_info', JSON.stringify(userData))
          this.initUserInfo()
        }
      })
    },
    editUser (type) {
      if (this.isKaowUser) {
        this.editUserFlag = type
        this.userEditVisible = true
      } else {
        this.$message.error('请到中心平台修改个人信息及密码.')
      }
    },
    editClose () {
      this.userEditVisible = false
    },
    initSchoolSuccess () {
      this.initSchoolBaseInfoVisible = false
    },
    upgradeSuccess () {
      this.upgradeVisible = false
    },
    chooseCurrentPosition () {
      console.log('chooseCurrentPosition', this.userPosition)
      if (!this.userPosition) {
        this.showPositionDialog()
      }
    },
    showPositionDialog (ableClose = true) {
      this.$store.commit('SHOW_CHOOSE_POSITION', {
        positionVisible: true,
        enableClose: false
      })
    },
    initUserInfo () {
      if (this.userInfo.status) {
        if (this.userInfo.icon !== '') {
          this.userImage = `${this.userInfo.icon}?t=${common.getTimeKey()}`
        } else {
          this.userImage = ''
        }
        this.userName = this.userInfo.name
        this.userTel = this.userInfo.mobilePhone
        this.userOrg = this.userInfo.origanizationName

        this.chooseCurrentPosition()
        // 密码提示
        if (sessionStorage.default_key && ['2', '3', '4'].includes(this.userInfo.role) && this.isKaowUser) {
          this.$notify({
            title: '温馨提示',
            type: 'warning',
            message: '使用初始密码存在安全隐患，请您尽快修改密码！',
            offset: 100,
            duration: 8000
          })
          sessionStorage.removeItem('default_key')
        }
      }
    },
    getSchoolStatus () {
      if (this.userInfo.role === common.systemRoleEnum.schoolInfoManager) {
        let param = {orgid: this.userInfo.origanization}
        isSchoolInitialized(param)
          .then((result) => {
            if (result.result.toString() === 'true') {
              if (!result.isInitialized) {
                this.initSchoolBaseInfoVisible = true
              } else {
                // 判断是否需要升级
                isNeedUpgrade(param)
                  .then((upResult) => {
                    if (upResult.result.toString() === 'true') {
                      if (upResult.isNeedUpgrade) {
                        this.upgradeVisible = true
                      }
                    }
                  })
              }
            } else {
              this.$message.error('获取学校初始化状态出错')
            }
          })
      }
    }
  },
  mounted () {
    console.log('mountedUserInfo')
    this.initUserInfo()
    this.getSchoolStatus()
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.user-detail-wrap{
  width: 100%;
  height: 280px;
  display: flex;
  background: #F7F7F4;
  flex-direction: column;
  align-items: center;
  .user-image{
    cursor: pointer;
    width: 75px;
    height: 75px;
    border: solid 8px white;
    border-radius: 50px;
    overflow: hidden;
    box-shadow: 0px 0px 13px 0px #888888;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .user-info{
    margin-top: 10px;
    width: 100%;
    display: flex;
    color: $color-text;
    justify-content: center;
    font-weight: 600;
  }
  .oprate-wrap{
    width: 180px;
    border-top: 1px solid $color-line;
    margin-top: 15px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    .oprate-edit-pwd{
      cursor: pointer;
      width: 100px;
      height: 60px;
      border-right: 1px solid $color-line;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      &:hover{
        color: $color-label;
      }
    }
    .oprate-edit-info{
      cursor: pointer;
      width: 100px;
      height: 60px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      &:hover{
        color: $color-label;
      }
    }
  }
}
.index-user-info-wrap{
  width: 162px;
  height: 166px;

  .back-ground-wrap{
    // width: 225px;
    // height: 230px;
    width: 162px;
    height: 166px;
    position: relative;
    box-shadow:-1px 0px 1px 0px #0c0c0c;
  }
  .user-image{
    cursor: pointer;
    position: absolute;
    background: white;
    top: 15px;
    left: 42px;
    width: 60px;
    height: 60px;
    border: solid 5px white;
    border-radius: 50px;
    overflow: hidden;
    box-shadow: 0px 0px 6px 0px #131212;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .user-org{
    width: 100%;
    position: absolute;
    display: flex;
    justify-content: center;
    color: white;
    top: 100px;
  }
  .user-name{
    width: 100%;
    position: absolute;
    display: flex;
    justify-content: center;
    color: white;
    top: 132px;
    font-size: 16px;
    font-weight: 600;
  }
  .triangle-down {
    position: absolute;
    width: 0;
    height: 0;
    // border-left: 60px solid transparent;
    // border-right: 165px solid transparent;
    // border-top: 169px solid #438B43;
    border-left: 43px solid transparent;
    border-right: 119px solid transparent;
    border-top: 122px solid #438B43;
  }
  .triangle-up {
    position: absolute;
    width: 0;
    height: 0;
    bottom: 0px;
    // border-left: 94px solid transparent;
    // border-right: 131px solid transparent;
    // border-bottom: 105px solid #408640;
    border-left: 68px solid transparent;
    border-right: 94px solid transparent;
    border-bottom: 76px solid #408640;
  }
  .triangle-left {
    position: absolute;
    width: 0;
    height: 0;
    right: 0px;
    // border-bottom: 100px solid transparent;
    // border-top: 130px solid transparent;
    // border-right: 135px solid #3D813D;
    border-bottom: 72px solid transparent;
    border-top: 94px solid transparent;
    border-right: 97px solid #3D813D;
  }
  .triangle-right {
    position: absolute;
    width: 0;
    height: 0;
    // border-top: 165px solid transparent;
    // border-bottom: 65px solid transparent;
    // border-left: 64px solid #469046;
    border-top: 119px solid transparent;
    border-bottom: 47px solid transparent;
    border-left: 46px solid #469046;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/IndexUserInfo.vue